// รวม logic แปลงสี rgba -> hex ที่เดิมซ้ำกันคนละรูปแบบใน
// EduPortalManagementEditPortal.jsx (rgba2hexa รับ object)
// EduPortalManagementCreatePortal.jsx (rgbaToHex รับ string "rgba(...)")

/**
 * แปลง object { r, g, b, a } (a เป็น 0-1) เป็น hex string เช่น "#3e94b5ff"
 * ใช้แทน rgba2hexa เดิมใน EditPortal (portal.theme.primaryColor เป็น object นี้)
 */
export const rgbaObjectToHex = ({ r, g, b, a }) => {
    const red = Number(r).toString(16).padStart(2, '0');
    const green = Number(g).toString(16).padStart(2, '0');
    const blue = Number(b).toString(16).padStart(2, '0');
    const alpha = Math.round(a * 255).toString(16).padStart(2, '0');
    return `#${red}${green}${blue}${alpha}`;
};

/**
 * แปลง string "rgba(r, g, b, a)" เป็น hex string
 * ใช้แทน rgbaToHex เดิมใน CreatePortal (ค่าธีมเริ่มต้น hardcode เป็น string)
 */
export const rgbaStringToHex = (rgba) => {
    const values = rgba
        .substring(rgba.indexOf('(') + 1, rgba.indexOf(')'))
        .split(',');
    const [r, g, b, a] = values.map((value) => parseInt(value.trim(), 10));
    return rgbaObjectToHex({ r, g, b, a });
};